import MediaInserterSelector from '@intercom/embercom-composer/components/media-inserter-social';
export default MediaInserterSelector;
